export default ['xs', 'sm', 'md', 'lg'];
export const viewportMediaQueries = [
  { xs: '(min-width:0px' },
  { sm: '(min-width: 768px)' },
  { md: '(min-width: 992px)' },
  { lg: '(min-width: 1200px)' }
];



// WEBPACK FOOTER //
// ./src/variables/viewports.js